import React from "react";
import { apiGet, Form, registerLookup } from "@redriver/cinnamon";

const NAMESPACE = "SIGNATORY/LOOKUPS";

const ActionTypes = {
  GetAuthorisedSignatoryStatus: `${NAMESPACE}/GET_AUTH_STATUS`,
};
export const authorisedSignatoryStatusLookup =
  "authorisedSignatoryStatusLookup";

registerLookup(
  authorisedSignatoryStatusLookup,
  () =>
    apiGet(
      ActionTypes.GetAuthorisedSignatoryStatus,
      "lookups/clients/authorised-signatories/status",
    ),
  {
    transform: (data) =>
      data.map((x) => {
        return {
          value: x.value,
          text: x.text,
        };
      }),
  },
);

const EditSignatoryForm = ({ isAuthorised, signatoryId, ...props }) => {
  return (
    <Form {...props}>
      <Form.Input field="name" label="Full Name" inline fluid required />
      <Form.Input field="position" label="Position" inline fluid required />

      <Form.Input
        field="phoneNumber"
        label="Phone Number"
        inline
        fluid
        required
      />
      <Form.Email
        field="email"
        label="Email"
        inline
        fluid
        emailValidation
        required
      />
      <Form.Input
        field="phoneCountryCode"
        label="Phone Country Code"
        inline
        fluid
        required
      />
      <Form.If condition={() => !isAuthorised}>
        <Form.If condition={() => props.value.isAuthorised}>
          <Form.Dropdown
            field="status"
            label="Authorised Status"
            placeholder="Auth Status"
            lookup={authorisedSignatoryStatusLookup}
            className="client-auth-sign-dropdown"
            required
            inline
            fluid
          />
        </Form.If>
        <Form.Checkbox field="isAuthorised" label="Authorised" inline fluid />
      </Form.If>
    </Form>
  );
};
export default EditSignatoryForm;
